import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { CiEdit } from "react-icons/ci";
import axios from "axios";
import AddZoneTrainerModal from "../Modals/ZoneTrainers/AddZoneTrainers";
import EditZoneTrainerModal from "../Modals/ZoneTrainers/EditZoneTrainers";
import { FaFacebook, FaInstagram, FaYoutube, FaLinkedin } from "react-icons/fa";

const ZoneTrainersPage = () => {
  const phone = atob(sessionStorage.getItem("mobile")); // Decrypt phone number from sessionStorage
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [member, setMember] = useState(null);
  const [zoneTrainers, setZoneTrainers] = useState([]);

  const trainingNames = [
    "JCI Orientation",
    "Effective Public Speaking",
    "Empowering Youth",
    "Future Leadership",
    "Leader Training Series",
    "LoId Training",
    "Business Trainings",
    "Industrial Trainings",
    "Institutional Trainings",
    "Others",
  ];

  // Fetch member and zone trainer data
  useEffect(() => {
    const fetchTrainerData = async () => {
      try {
        const response = await axios.get("/member/get_member_zone_trainer", {
          params: { contact_number: phone },
        });
        if (response.data) {
          setMember(response.data.member);
          setZoneTrainers(response.data.zone_trainer);
        }
      } catch (error) {
        console.error("Error fetching trainer data:", error);
        Swal.fire("Error", "Failed to fetch data.", "error");
      }
    };

    fetchTrainerData();
  }, [phone]);

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);

  const handleAddTrainer = (data) => {
    setZoneTrainers([
      ...zoneTrainers,
      { id: zoneTrainers.length + 1, ...data },
    ]);
    toggleModal();
  };

  const handleEditTrainer = (data) => {
    setZoneTrainers(
      zoneTrainers.map((trainer) =>
        trainer.id === data.id ? { ...trainer, ...data } : trainer
      )
    );
    toggleEditModal();
  };

  const handleDeleteTrainer = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setZoneTrainers(
          zoneTrainers.filter((trainer) => trainer.zone_trainer_id !== id)
        );
        Swal.fire("Deleted!", "Your record has been deleted.", "success");
      }
    });
  };

  const openEditModal = (record, ZoneTrainers, member) => {
    setSelectedRecord(record);
    setMember(member);
    setZoneTrainers(ZoneTrainers);
    toggleEditModal();
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensures 2 digits for the day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensures 2 digits for the month (Months are 0-indexed)
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const url = sessionStorage.getItem("url");

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      {/* My Profile Heading */}
      <h2 className="text-2xl font-bold mb-6 text-center md:text-left">
        My Profile
      </h2>

      {/* Profile Section */}
      <div className="relative bg-white shadow-lg rounded-lg p-6 flex flex-col sm:flex-row items-center sm:items-start space-y-6 sm:space-y-0 sm:space-x-6">
        {/* Edit Button */}
        {zoneTrainers.map((trainer) => (
          <button
            key={trainer.member_id}
            type="button"
            className="absolute top-4 right-4 flex items-center space-x-2 py-2.5 px-5 text-sm font-medium text-gray-900 bg-white rounded-full border-2 border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:outline-none focus:ring-4 focus:ring-gray-100"
            onClick={() => openEditModal(trainer, zoneTrainers, member)}
          >
            <span className="text-[#737578] font-semibold hover:text-blue-700">
              Edit
            </span>
            <CiEdit />
          </button>
        ))}

        {/* Profile Image */}
        {zoneTrainers.map((trainer) => (
          <div key={trainer.member_id} className="flex-shrink-0">
            <img
              // src={profile_url ? `${url}/members/members_images/${profile_url}` : '/default_avatar.png'}
              src={
                trainer.images
                  ? `${url}/member/zone_trainers_images/${trainer.images}`
                  : "/default_avatar.png"
              }
              alt="Profile"
              className="w-24 h-24 sm:w-32 sm:h-32 rounded-full object-cover border border-gray-300"
            />
          </div>
        ))}

        {/* Profile Details */}
        <div className="flex-grow text-center sm:text-left">
          {zoneTrainers.map((trainer) => (
            <div key={trainer.member_id}>
              {member && (
                <>
                  <h4 className="text-xl sm:text-xl font-bold">
                    {member.name || "-"}
                  </h4>
                  <p className="text-[#737578]">{member.lom_name || "-"}</p>
                </>
              )}
              <p className="text-[#737578]">{trainer.district_name || "-"}</p>
              <p className="text-[#737578]">
                {trainer.trainer_from_zone_18 === "Yes" ? "Zone 18" : "-"}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Personal Information Section */}
      <div className="bg-white shadow-lg rounded-lg p-6">
        <h3 className="text-xl font-bold mb-4 text-center md:text-left">
          Personal Information
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-6">
          {zoneTrainers.map((trainer) => (
            <>
              <div key="highestPortfolio">
                <label className="block font-medium text-[#737578]">
                  Highest Portfolio in JCI
                </label>
                <p className="text-black">{trainer.highest_portfolio || "-"}</p>
              </div>
              <div key="year">
                <label className="block font-medium text-[#737578]">
                  Highest Portfolio Year
                </label>
                <p className="text-black">{trainer.portfolio_year || "-"}</p>
              </div>
              <div key="dob">
                <label className="block font-medium text-[#737578]">
                  Date of Birth
                </label>
                <p className="text-black">
                  {trainer.dob ? formatDate(trainer.dob) : "-"}
                </p>
              </div>
              <div key="qualification">
                <label className="block font-medium text-[#737578]">
                  Education Qualification
                </label>
                <p className="text-black">
                  {trainer.education_qualification || "-"}
                </p>
              </div>
              <div key="graduated">
                <label className="block font-medium text-[#737578]">
                  Graduated
                </label>
                <p className="text-black">{trainer.graduated || "-"}</p>
              </div>
              <div key="graduatedYear">
                <label className="block font-medium text-[#737578]">
                  Graduated Year
                </label>
                <p className="text-black">{trainer.graduated_year || "-"}</p>
              </div>
              <div key="loLevelTrainings">
                <label className="block font-medium text-[#737578]">
                  Number of LO Level Trainings as a Faculty
                </label>
                <p className="text-black">
                  {trainer.no_of_lo_level_trainings || "-"}
                </p>
              </div>
              <div key="corporateTrainings">
                <label className="block font-medium text-[#737578]">
                  Number of Trainings Conducted at Corporate / business
                  environment
                </label>
                <p className="text-black">
                  {trainer.no_of_corporate_trainings || "-"}
                </p>
              </div>
              <div key="trainingsOffered">
                <label className="block font-medium text-[#737578]">
                  Trainings I Would Love to Offer
                </label>
                <p className="text-black">
                  {trainer.selectedTrainingIds
                    ? trainer.selectedTrainingIds
                        .split(",") // Split the string into an array (e.g., '1,2' => ['1', '2'])
                        .map((id) => trainingNames[parseInt(id) - 1]) // Subtract 1 from ID to match the correct index in the array
                        .join(", ") // Join them into a comma-separated list
                    : "-"}
                </p>
              </div>
              <div key="trainingSpecialization">
                <label className="block font-medium text-[#737578]">
                  Area of Training Specialization
                </label>
                <p className="text-black">
                  {trainer.highest_position_training || "-"}
                </p>
              </div>
              <div className="space-y-2">
                <label className="block font-medium text-[#737578]">
                  Social Media
                </label>
                <div className="flex space-x-4">
                  {/* <a
                    href={trainer.facebook || "#"}
                    target={trainer.facebook ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      if (!trainer.facebook) {
                        e.preventDefault(); // Prevents navigation if no value is present
                      }
                    }}
                  >
                    <FaFacebook
                      className={`text-blue-500 ${
                        !trainer.facebook ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    />
                  </a>
                  <a
                    href={trainer.instagram || "#"}
                    target={trainer.instagram ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      if (!trainer.instagram) {
                        e.preventDefault(); // Prevent navigation if no value is present
                      }
                    }}
                  >
                    <FaInstagram
                      className={`text-pink-500 ${
                        !trainer.instagram ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    />
                  </a>
                  <a
                    href={trainer.youtube || "#"}
                    target={trainer.youtube ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      if (!trainer.youtube) {
                        e.preventDefault(); // Prevent navigation if no value is present
                      }
                    }}
                  >
                    <FaYoutube
                      className={`text-red-500 ${
                        !trainer.youtube ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    />
                  </a>
                  <a
                    href={trainer.linkedin || "#"}
                    target={trainer.linkedin ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      if (!trainer.linkedin) {
                        e.preventDefault(); // Prevent navigation if no value is present
                      }
                    }}
                  >
                    <FaLinkedin
                      className={`text-blue-700 ${
                        !trainer.linkedin ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    />
                  </a> */}
                   {/* Social Media Icons */}
                                     
                    {trainer.facebook ||
                      trainer.instagram ||
                      trainer.youtube ||
                      trainer.linkedin ? (
                      <div>
                        {" "}
                        <div className="flex space-x-2">
                          <a
                            href={trainer.facebook || "/login"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                          {trainer.facebook ? (
                            <FaFacebook
                              className={`text-blue-500 ${
                              !trainer.facebook &&
                              "opacity-50 cursor-pointer"
                            }`}
                          />
                          ) : (
                          []
                        )}
                        </a>
                        <a
                        href={trainer.instagram || "/login"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                      {trainer.instagram ? (
                      <FaInstagram
                        className={`text-red-800 ${
                        !trainer.instagram &&
                        "opacity-50 cursor-pointer"
                      }`}
                      />
                      ) : (
                      []
                      )}
                      </a>
                      <a
                        href={trainer.youtube || "/login"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                      {" "}
                      {trainer.youtube ? (
                        <FaYoutube
                            className={`text-red-500 ${
                            !trainer.youtube &&
                            "opacity-50 cursor-pointer"
                          }`}
                      />
                      ) : (
                        []
                     )}
                      </a>
                      <a
                      href={trainer.linkedin || "/login"}
                      target="_blank"
                      rel="noopener noreferrer"
                      >
                      {trainer.linkedin ? (
                      <FaLinkedin
                          className={`text-blue-700 ${
                          !trainer.linkedin &&
                        "opacity-50 cursor-pointer"
                       }`}
                      />
                      ) : (
                     []
                   )}
                  </a>
                </div>
              </div>
               ) : (
                <div>-</div>
                )}
                                                      
                </div>
              </div>

              {/* <div key="instagramId">
                <label className="block font-medium text-[#737578]">
                  Instagram Id Name
                </label>
                <p className="text-black">{trainer.instagram_id || "-"}</p>
              </div> */}
              
             
            </>
          ))}
        </div>
      </div>

      {/* Address Section */}
      <div className="bg-white shadow-lg rounded-lg p-6">
        <h3 className="text-xl font-bold mb-4 text-center md:text-left">
          Address
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-6">
          {zoneTrainers.map((trainer) => (
            <>
              <div key="communicationAddress">
                <label className="block font-medium text-[#737578]">
                  Communication Address
                </label>
                <p className="text-black">{trainer.address || "-"}</p>
              </div>
              <div key="whatsappNo">
                <label className="block font-medium text-[#737578]">
                  WhatsApp Number
                </label>
                <p className="text-black">{trainer.whatsapp_number || "-"}</p>
              </div>
              {member && (
                <div key="whatsappNo">
                  <label className="block font-medium text-[#737578]">
                    Contact Number
                  </label>
                  <p className="text-black">{member.contact_number || "-"}</p>
                </div>
              )}
            </>
          ))}
        </div>
      </div>

      <AddZoneTrainerModal
        show={isModalOpen}
        onClose={toggleModal}
        onSubmit={handleAddTrainer}
      />
      {isEditModalOpen && selectedRecord && (
        <EditZoneTrainerModal
          show={isEditModalOpen}
          onClose={toggleEditModal}
          onSubmit={handleEditTrainer}
          initialData={selectedRecord}
          member={member} // Pass member data
          zoneTrainers={zoneTrainers} // Pass zoneTrainers data
        />
      )}
    </div>
  );
};

export default ZoneTrainersPage;
